var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.34,
    height: 30.6,
    viewBox: "0 0 34.34 30.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M139.21,165h34.34v30.6H139.21Z",
    fill: "#ff7200"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Booking",
    "data-name": "Total Booking",
    transform: "translate(-139.21 -165)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M146.112,165.49a1.073,1.073,0,0,0-1.062,1.086v1.308H140.09a1.073,1.073,0,0,0-1.077,1.077v6.108h0a1.076,1.076,0,0,0,0,.656V187.37a1.073,1.073,0,0,0,1.077,1.069h17.182a8.04,8.04,0,1,0,10.386-8.151V168.961a1.074,1.074,0,0,0-1.077-1.077h-4.959v-1.308a1.073,1.073,0,1,0-2.146,0v1.308H147.195v-1.308a1.073,1.073,0,0,0-1.084-1.086Zm-4.953,4.54h3.89v1.306a1.073,1.073,0,1,0,2.146,0V170.03h12.281v1.306a1.073,1.073,0,1,0,2.146,0V170.03h3.89v4.293H141.159Zm0,6.441h24.353v3.471c-.072,0-.142-.01-.214-.01-.244,0-.485.015-.721.038a8.068,8.068,0,0,0-7.147,6.324H141.159Zm24.131,5.607h.008a5.946,5.946,0,0,1,1.084.1h0a1.048,1.048,0,0,0,.107.014,5.9,5.9,0,1,1-7.093,5.774c0-.15.01-.3.021-.442h0c0-.023.008-.047.01-.071a5.879,5.879,0,0,1,1.159-3.035l.01-.015a5.893,5.893,0,0,1,.7-.769l.029-.027a5.887,5.887,0,0,1,.819-.623l.033-.021a5.877,5.877,0,0,1,.93-.472l.025-.008a5.877,5.877,0,0,1,1.025-.3c.059-.011.12-.018.18-.027.124-.02.248-.042.375-.054h.006c.187-.018.376-.029.568-.029Zm2.525,2.83a1.072,1.072,0,0,0-.744.316l-2.962,2.884-.356-.824a1.073,1.073,0,1,0-1.974.838l.968,2.266a1.073,1.073,0,0,0,1.733.348l4.087-3.976a1.073,1.073,0,0,0-.753-1.853Z",
    transform: "translate(0.231 -0.454)",
    fill: "#ff7200"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBooking);
export default __webpack_public_path__ + "static/media/TotalBooking.e8a349ed8ee3a0626de2c56985d8a58c.svg";
export { ForwardRef as ReactComponent };